export default __webpack_public_path__ + "static/media/folder.fa0760d2.svg";